import get from 'lodash.get';
import { emptyObject } from '../../../default-props/empty';

export const selectSearchData = (state) => get(state, 'searchData', emptyObject);
export const selectOrderAlertCount = (state) => get(state, 'orderAlertsCount', 0);
export const selectStatusCountMap = (state) => get(state, 'statusCountMap', emptyObject);
